var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2978 10.7397H12.5147C11.4013 10.7397 10.8447 10.7397 10.4194 10.9563C10.0454 11.1469 9.74125 11.4511 9.55066 11.8251C9.33398 12.2504 9.33398 12.807 9.33398 13.9204V19.4866C9.33398 20.6 9.33398 21.1566 9.55066 21.5819C9.74125 21.9559 10.0454 22.2601 10.4194 22.4506C10.8447 22.6673 11.4013 22.6673 12.5147 22.6673H18.0809C19.1943 22.6673 19.751 22.6673 20.1762 22.4506C20.5503 22.2601 20.8544 21.9559 21.045 21.5819C21.2616 21.1566 21.2616 20.6 21.2616 19.4866V16.7035M13.3098 18.6914H14.4195C14.7436 18.6914 14.9057 18.6914 15.0582 18.6548C15.1935 18.6224 15.3227 18.5688 15.4413 18.4961C15.5751 18.4142 15.6897 18.2996 15.9189 18.0704L22.2556 11.7336C22.8046 11.1847 22.8046 10.2947 22.2556 9.7457C21.7066 9.19675 20.8166 9.19675 20.2677 9.7457L13.9309 16.0824C13.7017 16.3116 13.5871 16.4262 13.5051 16.56C13.4325 16.6786 13.3789 16.8078 13.3465 16.9431C13.3098 17.0956 13.3098 17.2577 13.3098 17.5818V18.6914Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.f000e9cafa1b6c043506e526a033ad28.svg";
export { ForwardRef as ReactComponent };